import { styled } from '@linaria/react';

import { OddsTableHeadersContainer } from '../outright-markets/style';

export const OutrightsWrapper = styled.div`
  padding-bottom: 20px;
`;

export const OutrightMarketsTabWrapper = styled.div`
  & ${OddsTableHeadersContainer} {
    padding: 20px 0 15px;

    @media (min-width: 768px) {
      padding: 15px 0;
    }
  }
`;

export const OtherOutrightsTableTabWrapper = styled.div`
  margin: 0 0 30px;

  @media (min-width: 768px) {
    margin: 20px 0;
  }
`;
